import React, { useEffect, useRef } from 'react';
import { Form } from 'react-bootstrap';
import _ from 'lodash';
import { useIsMount } from '../../../hooks/useIsMountHook';

interface StatefulInputProps {
  value: string;
  onChange: (value: string) => void;
}

const StatefulInput = ({ value, onChange }: StatefulInputProps) => {
  const [inputValue, setInputValue] = React.useState(value);

  const isMount = useIsMount();

  useEffect(() => {
    if (!isMount) {
      onChangeDebounced(inputValue);
    }
  }, [inputValue]);

  const onChangeDebounced = useRef(
    _.debounce(inputValue => {
      onChange(inputValue);
    }, 600),
  ).current;

  return (
    <Form.Control
      value={inputValue}
      onChange={e => {
        setInputValue(e.target.value);
      }}
    />
  );
};

export default StatefulInput;
